import { ReactElement, useRef } from "react";
import { useOption } from "react-aria";
import { ListState, Node } from "react-stately";
import cn from "classnames";

import * as styles from "@core/ui/atoms/list-box-option/ListBoxOption.module.scss";

interface ListBoxOptionProps {
  item: Node<unknown>;
  state: ListState<unknown>;
}

const ListBoxOption = ({ item, state }: ListBoxOptionProps): ReactElement => {
  const ref = useRef<HTMLLIElement>(null);
  const { optionProps, isSelected } = useOption({ key: item.key }, state, ref);

  return (
    <li
      {...optionProps}
      ref={ref}
      className={cn(styles.listBoxOption, {
        [styles.isSelected]: isSelected,
      })}
    >
      {item.rendered}
    </li>
  );
};

export default ListBoxOption;
